export const ICON_SIZES = {
  SM: 24,
  MD: 32,
  LG: 48,
  XL: 56,
};

export const ICON_VARIANTS = {
  STANDARD: [ICON_SIZES.SM, ICON_SIZES.MD],
  DETAILED: [ICON_SIZES.LG, ICON_SIZES.XL],
};
